export const openExternalUrl = (url: string) => window.open(url, '_blank');

export const openExternalUrlSelf = (url: string) => window.open(url, '_self');
